import React from 'react';

const ArrowRoundBack = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
      <path
        d="M5 19.4336C4.58579 19.4336 4.25 19.7694 4.25 20.1836C4.25 20.5978 4.58579 20.9336 5 20.9336V19.4336ZM4.46967 7.65326C4.17678 7.94616 4.17678 8.42103 4.46967 8.71392L9.24264 13.4869C9.53553 13.7798 10.0104 13.7798 10.3033 13.4869C10.5962 13.194 10.5962 12.7191 10.3033 12.4262L6.06066 8.18359L10.3033 3.94095C10.5962 3.64806 10.5962 3.17319 10.3033 2.88029C10.0104 2.5874 9.53553 2.5874 9.24264 2.88029L4.46967 7.65326ZM5 20.9336H16V19.4336H5V20.9336ZM16 7.43359H5V8.93359H16V7.43359ZM22.75 14.1836C22.75 10.4557 19.7279 7.43359 16 7.43359V8.93359C18.8995 8.93359 21.25 11.2841 21.25 14.1836H22.75ZM16 20.9336C19.7279 20.9336 22.75 17.9115 22.75 14.1836H21.25C21.25 17.0831 18.8995 19.4336 16 19.4336V20.9336Z"
        fill="black"
      />
    </svg>
  );
};

export { ArrowRoundBack };
